<template>
  <van-popup v-model="showDetail" round closeable position="bottom" :style="{ height: '60%' }">
    <div class="search-box">
      <div class="search-container">
        <div class="search-icon"></div>
        <van-field
          class="search-input"
          v-model="searchValue"
          @input="inputChange"
          placeholder="请输入搜索关键词"
        />
      </div>
      <div class="search-result">
        <van-list
          v-if="curList.length"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell
            @click="selectSchool(item)"
            class="result-item"
            v-for="item in curList"
            :key="item.schoolId + item.schoolName"
          >
            {{ item.schoolName }}
          </van-cell>
        </van-list>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { debounce } from '@/utils'
import { getDistrictSchool } from '../../api/personInfo'

let debounceFn = () => {}

export default {
  data() {
    return {
      showDetail: false,
      searchValue: '',
      districtCode: '',
      curList: [],
      schoolList: [],
      finished: false,
      loading: false,
      step: 10,
      key: 0
    }
  },
  methods: {
    show(districtCode) {
      this.key++
      this.districtCode = districtCode
      this.reset()
      this.showDetail = true
      this.queryDistrictSchool()
    },
    queryDistrictSchool() {
      this.$toast.loading({
        message: '加载中',
        forbidClick: true,
        overlay: true
      })
      getDistrictSchool({
        districtCode: this.districtCode
      })
        .then(res => {
          this.schoolList = res.data
          if (this.schoolList.length >= this.step) {
            this.curList = this.schoolList.slice(0, 10)
          }
          debounceFn = debounce(this.searchByInput, 1500, false)
          this.$toast.clear()
        })
        .catch(e => {
          this.$toast.clear()
        })
    },
    onLoad() {
      console.log('onLoad===>', this.curList)
      setTimeout(() => {
        this.curList = this.curList.concat(this.schoolList.slice(this.step, this.step + 10))
        this.step += 10
        // 加载状态结束
        this.loading = false

        // 数据全部加载完成
        if (this.curList.length >= this.schoolList.length) {
          this.finished = true
        }
      }, 100)
    },
    selectSchool(item) {
      this.showDetail = false
      this.$emit('changeSchool', item)
    },
    inputChange(val) {
      debounceFn()
    },
    searchByInput() {
      this.curList = this.schoolList.filter(item => item.schoolName.includes(this.searchValue))
    },
    reset() {
      this.curList = []
      this.step = 10
      this.searchValue = ''
      this.finished = false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  width: 100%;
  height: 100%;
  padding: 45px 40px;
  box-sizing: border-box;
}
.search-container {
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 580px;
  height: 66px;
  line-height: 66px;
  padding: 1px;
  background: #ffffff;
  border: 2px solid #e6e6e6;
  border-radius: 10px;
  .search-icon {
    width: 26px;
    height: 26px;
    margin-left: 10px;
    background: url('~paintingCompetition/assets/personInfo/icon_search.png') no-repeat;
    background-size: 100% auto;
  }
  .search-input {
    padding: 10px 16px;
    border-radius: 10px;
  }
}
.search-result {
  height: 85%;
  overflow: auto;
  margin-top: 80px;
  /deep/ .result-item {
    padding: 30px 0;
    font-size: 30px;
    font-weight: normal;
    color: #333333;
    &::after {
      left: 0;
      border-bottom: 1px solid #e6e6e6;
    }
  }
}
</style>
